enum AssignTenantModalActionType {
    Assign = 'Assign',
    Cancel = 'Cancel',
    AssignAndArchive = 'AssignAndArchive',
}

export default AssignTenantModalActionType
